module.exports = "<div class=\"subscribe_result\" id=\"subscribe_success\" [@resultState]=\"state\">\n  <div class=\"subscribe_res_text_container\">\n      <p>\n          Your email was added successfully!\n      </p>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/subscribe-result-success/subscribe-result-success.component.html
// module id = ./src/app/components/subscribe-result-success/subscribe-result-success.component.html
// module chunks = main